import VolatilityMessageComponent from "../layout/VolatilityMessageComponent";


const OnboardingMessageList = () => {

  return (
      <VolatilityMessageComponent type="ONBOARDING" />
  );
};
export default OnboardingMessageList;
